import type { FC, ReactNode } from 'react'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PageHero } from '@/components/generals/page-hero'
import { ClosingCta } from '@/components/generals/closing-cta'
import { LogoTicker } from '@/components/generals/logo-ticker'
import { ScoutedThenHired } from '@/components/placements/scouted-then-hired'
import { Testimonials, WantToSeeMore } from '@/components/placements/sections'
import { routes } from '@/constants/site'

const Placements: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Placements'
                description="Meet the designers who were scouted through the network and joined teams you'd recognise."
            />

            <PageHero
                title='See where scouted designers landed'
                sub="Meet the designers who were scouted through the network and joined teams you'd recognise"
                primary={{ label: 'Get started', href: routes.getStarted }}
                secondary={{ label: 'How it works', href: routes.howItWorks }}
            >
                <LogoTicker label='From our network, hired by' className='enter mt-[clamp(48px,5vw,72px)]' />
            </PageHero>

            <ScoutedThenHired />
            <WantToSeeMore />
            <Testimonials />
            <ClosingCta />
        </Layout>
    )
}

export default Placements
